export class SectionControls {
  constructor(controller) {
    this.controller = controller;
    this.eventListeners = [];
  }

  initializeSectionControls() {
    // Store bound function reference for cleanup
    this.clickHandler = (e) => {
      if (e.target.closest('.section-controls .btn-danger')) {
        const deleteBtn = e.target.closest('.section-controls .btn-danger');
        const section = deleteBtn.closest('section');

        console.log('Кнопка удаления нажата для раздела:', section.id);

        e.preventDefault();
        e.stopPropagation();
        if (confirm('Вы уверены, что хотите удалить этот раздел?')) {
          this.deleteSection(section);
        }
      } else if (e.target.closest('.section-controls .btn-info')) {
        const refineBtn = e.target.closest('.section-controls .btn-info');
        const section = refineBtn.closest('section');

        console.log('Кнопка улучшения нажата для раздела:', section.id);

        e.preventDefault();
        e.stopPropagation();

        this.showRefineModal(section);
      } else if (e.target.closest('.section-controls .btn-success')) {
        const saveBtn = e.target.closest('.section-controls .btn-success');
        const section = saveBtn.closest('section');

        console.log('Кнопка сохранения нажата для раздела:', section.id);

        e.preventDefault();
        e.stopPropagation();
        this.saveSection(section);
      } else if (e.target.closest('.section-controls .btn-secondary')) {
        const btn = e.target.closest('.section-controls .btn-secondary');
        const section = btn.closest('section');

        e.preventDefault();

        // Check if it's up or down button based on icon
        if (btn.querySelector('.fa-arrow-up')) {
          this.moveSectionUp(section);
        } else if (btn.querySelector('.fa-arrow-down')) {
          this.moveSectionDown(section);
        }
      }
    };

    // Add delegated event listener for all section control buttons
    document.addEventListener('click', this.clickHandler);

    // Track for cleanup
    this.eventListeners.push({
      element: document,
      event: 'click',
      handler: this.clickHandler
    });

    document.querySelectorAll('section').forEach(section => {
      this.createSectionControls(section);
    });
    // Add for footer and navbar
    document.querySelectorAll('footer').forEach(footer => {
      this.createFooterControls(footer);
    });
    document.querySelectorAll('nav').forEach(navbar => {
      this.createNavbarControls(navbar);
    });
  }

  createSectionControls(section) {
    // Create control container
    const controls = document.createElement('div');
    controls.className = 'section-controls';
    controls.style.cssText = `
      position: absolute;
      top: 5px;
      right: 10px;
      z-index: 9000;
      display: flex;
      gap: 5px;
      opacity: 0;
      transition: opacity 0.3s;
    `;

    const refineBtn = document.createElement('button');
    refineBtn.innerHTML = '<i class="fas fa-magic"></i>';
    refineBtn.className = 'btn btn-sm btn-info';
    refineBtn.title = 'Улучшить раздел';
    refineBtn.style.cssText = 'padding: 5px 8px; font-size: 12px; z-index: 9000;';

    const saveBtn = document.createElement('button');
    saveBtn.innerHTML = '<i class="fas fa-save"></i>';
    saveBtn.className = 'btn btn-sm btn-success';
    saveBtn.title = 'Сохранить раздел';
    saveBtn.style.cssText = 'padding: 5px 8px; font-size: 12px; z-index: 9000;';

    const upBtn = document.createElement('button');
    upBtn.innerHTML = '<i class="fas fa-arrow-up"></i>';
    upBtn.className = 'btn btn-sm btn-secondary';
    upBtn.title = 'Переместить вверх';
    upBtn.style.cssText = 'padding: 5px 8px; font-size: 12px; z-index: 9000;';

    const downBtn = document.createElement('button');
    downBtn.innerHTML = '<i class="fas fa-arrow-down"></i>';
    downBtn.className = 'btn btn-sm btn-secondary';
    downBtn.title = 'Переместить вниз';
    downBtn.style.cssText = 'padding: 5px 8px; font-size: 12px; z-index: 9000;';

    const deleteBtn = document.createElement('button');
    deleteBtn.innerHTML = '<i class="fas fa-trash"></i>';
    deleteBtn.className = 'btn btn-sm btn-danger';
    deleteBtn.title = 'Удалить раздел';
    deleteBtn.style.cssText = 'padding: 5px 8px; font-size: 12px; z-index: 9000;';

    // Add buttons to controls
    controls.appendChild(upBtn);
    controls.appendChild(downBtn);
    controls.appendChild(refineBtn);
    controls.appendChild(saveBtn);
    controls.appendChild(deleteBtn);

    // Store event handlers for cleanup
    const mouseEnterHandler = () => {
      controls.style.opacity = '1';
      section.style.border = '2px dashed #000000ff';
    };

    const mouseLeaveHandler = () => {
      controls.style.opacity = '0';
      section.style.border = '';
    };

    // Make section position relative and add hover effect
    section.style.position = 'relative';
    section.addEventListener('mouseenter', mouseEnterHandler);
    section.addEventListener('mouseleave', mouseLeaveHandler);

    // Store handlers on the section for later cleanup
    section._sectionEventHandlers = {
      mouseEnterHandler,
      mouseLeaveHandler
    };

    // Insert controls at the end of the section
    section.appendChild(controls);
  }

  createFooterControls(footer) {
    // Create control container
    const controls = document.createElement('div');
    controls.className = 'footer-controls';
    controls.style.cssText = `
      position: absolute;
      top: 5px;
      right: 10px;
      z-index: 9000;
      display: flex;
      gap: 5px;
      opacity: 0;
      transition: opacity 0.3s;
    `;

    const refineBtn = document.createElement('button');
    refineBtn.innerHTML = '<i class="fas fa-magic"></i>';
    refineBtn.className = 'btn btn-sm btn-info';
    refineBtn.title = 'Улучшить футер';
    refineBtn.style.cssText = 'padding: 5px 8px; font-size: 12px; z-index: 9000;';

    const saveBtn = document.createElement('button');
    saveBtn.innerHTML = '<i class="fas fa-save"></i>';
    saveBtn.className = 'btn btn-sm btn-success';
    saveBtn.title = 'Сохранить футер';
    saveBtn.style.cssText = 'padding: 5px 8px; font-size: 12px; z-index: 9000;';

    controls.appendChild(refineBtn);
    controls.appendChild(saveBtn);

    // Modal for "refine"
    refineBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.showRefineModalForElement(footer, 'footer');
    });

    // Save handler for footer
    saveBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.saveFooter(footer);
    });

    // Hover effect
    const mouseEnterHandler = () => {
      controls.style.opacity = '1';
      footer.style.border = '2px dashed #000000ff';
    };
    const mouseLeaveHandler = () => {
      controls.style.opacity = '0';
      footer.style.border = '';
    };

    footer.style.position = 'relative';
    footer.addEventListener('mouseenter', mouseEnterHandler);
    footer.addEventListener('mouseleave', mouseLeaveHandler);

    footer._footerEventHandlers = {
      mouseEnterHandler,
      mouseLeaveHandler
    };

    footer.appendChild(controls);
  }

  createNavbarControls(navbar) {
    // Create control container
    const controls = document.createElement('div');
    controls.className = 'navbar-controls';
    controls.style.cssText = `
      position: absolute;
      top: 5px;
      right: 10px;
      z-index: 9000;
      display: flex;
      gap: 5px;
      opacity: 0;
      transition: opacity 0.3s;
    `;

    const refineBtn = document.createElement('button');
    refineBtn.innerHTML = '<i class="fas fa-magic"></i>';
    refineBtn.className = 'btn btn-sm btn-info';
    refineBtn.title = 'Улучшить меню';
    refineBtn.style.cssText = 'padding: 5px 8px; font-size: 12px; z-index: 9000;';

    const saveBtn = document.createElement('button');
    saveBtn.innerHTML = '<i class="fas fa-save"></i>';
    saveBtn.className = 'btn btn-sm btn-success';
    saveBtn.title = 'Сохранить меню';
    saveBtn.style.cssText = 'padding: 5px 8px; font-size: 12px; z-index: 9000;';

    controls.appendChild(refineBtn);
    controls.appendChild(saveBtn);

    // Modal for "refine"
    refineBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.showRefineModalForElement(navbar, 'navbar');
    });

    // Save handler for navbar
    saveBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.saveNavbar(navbar);
    });

    // Hover effect
    const mouseEnterHandler = () => {
      controls.style.opacity = '1';
      navbar.style.border = '2px dashed #000000ff';
    };
    const mouseLeaveHandler = () => {
      controls.style.opacity = '0';
      navbar.style.border = '';
    };

    navbar.style.position = 'relative';
    navbar.addEventListener('mouseenter', mouseEnterHandler);
    navbar.addEventListener('mouseleave', mouseLeaveHandler);

    navbar._navbarEventHandlers = {
      mouseEnterHandler,
      mouseLeaveHandler
    };

    navbar.appendChild(controls);
  }

  showRefineModalForElement(element, type) {
    // Remove any existing refine input
    const existingRefineInput = document.querySelector('.refine-input-container');
    if (existingRefineInput) {
      existingRefineInput.remove();
    }

    // Create compact input container
    const refineContainer = document.createElement('div');
    refineContainer.className = 'refine-input-container';
    refineContainer.style.cssText = `
      position: absolute;
      top: 40px;
      right: 10px;
      background: white;
      border: 1px solid #ced4da;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      padding: 12px;
      z-index: 9001;
      width: 300px;
      max-width: calc(100vw - 40px);
    `;

    // Create input field
    const textarea = document.createElement('textarea');
    textarea.placeholder = 'Введите запрос на изменение...';
    textarea.style.cssText = `
      width: 100%;
      min-height: 80px;
      padding: 8px;
      border: 1px solid #ced4da;
      border-radius: 4px;
      font-family: inherit;
      font-size: 13px;
      resize: vertical;
      box-sizing: border-box;
      margin-bottom: 8px;
    `;

    // Create button container
    const buttonContainer = document.createElement('div');
    buttonContainer.style.cssText = `
      display: flex;
      justify-content: flex-end;
      gap: 6px;
    `;

    const cancelButton = document.createElement('button');
    cancelButton.textContent = 'Отмена';
    cancelButton.style.cssText = `
      padding: 4px 8px;
      border: 1px solid #6c757d;
      background: #6c757d;
      color: white;
      border-radius: 3px;
      cursor: pointer;
      font-size: 12px;
    `;

    const refineButton = document.createElement('button');
    refineButton.textContent = 'Улучшить';
    refineButton.style.cssText = `
      padding: 4px 8px;
      border: 1px solid var(--primary-color);
      background: green;
      color: white;
      border-radius: 3px;
      cursor: pointer;
      font-size: 12px;
    `;

    buttonContainer.appendChild(cancelButton);
    buttonContainer.appendChild(refineButton);

    refineContainer.appendChild(textarea);
    refineContainer.appendChild(buttonContainer);

    // Add to element
    element.appendChild(refineContainer);

    // Focus on textarea
    textarea.focus();

    // Event handlers
    const closeRefineInput = () => {
      refineContainer.remove();
    };

    cancelButton.addEventListener('click', closeRefineInput);

    // Close when clicking outside
    const handleClickOutside = (e) => {
      if (!refineContainer.contains(e.target)) {
        closeRefineInput();
        document.removeEventListener('click', handleClickOutside);
      }
    };
    setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 100);

    // Handle escape key
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeRefineInput();
        document.removeEventListener('keydown', handleKeyDown);
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    // Handle refine button click
    refineButton.addEventListener('click', () => {
      const modificationRequest = textarea.value.trim();
      if (!modificationRequest) {
        this.controller.showToaster('Пожалуйста, введите запрос на изменение');
        return;
      }
      closeRefineInput();
      if (type === 'footer') {
        this.refineFooter(element, modificationRequest);
      } else if (type === 'navbar') {
        this.refineNavbar(element, modificationRequest);
      }
    });
  }

  async refineFooter(footer, modificationRequest) {
    // Get pageId from URL (number after 'pages/')
    const match = window.location.pathname.match(/pages\/(\d+)/);
    const pageId = match ? match[1] : null;

    if (!pageId) {
      this.controller.showToaster('Не удалось определить ID страницы');
      return;
    }

    // Create and show loader
    const loader = this.createLoader();
    footer.appendChild(loader);

    try {
      const response = await fetch(`/api/v1/page_editor/refine_footer?page_id=${pageId}&modification_request=${encodeURIComponent(modificationRequest)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });

      // Remove loader
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }

      if (response.ok) {
        const data = await response.json();
        // Update the footer content
        footer.outerHTML = data.footer;
        this.controller.showToaster('Футер успешно улучшен');
      } else {
        const errorData = await response.json();
        console.error('Ошибка при улучшении футера:', errorData);
        this.controller.showToaster(errorData.error || 'Не удалось улучшить футер');
      }
    } catch (error) {
      console.error('Ошибка при улучшении футера:', error);
      this.controller.showToaster('Ошибка при улучшении футера');
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }
  }

  async refineNavbar(navbar, modificationRequest) {
    // Get pageId from URL (number after 'pages/')
    const match = window.location.pathname.match(/pages\/(\d+)/);
    const pageId = match ? match[1] : null;

    if (!pageId) {
      this.controller.showToaster('Не удалось определить ID страницы');
      return;
    }

    // Create and show loader
    const loader = this.createLoader();
    navbar.appendChild(loader);

    try {
      const response = await fetch(`/api/v1/page_editor/refine_header?page_id=${pageId}&modification_request=${encodeURIComponent(modificationRequest)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });

      // Remove loader
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }

      if (response.ok) {
        const data = await response.json();
        // Update the navbar content
        navbar.outerHTML = data.header;
        this.controller.showToaster('Меню успешно улучшено');
      } else {
        const errorData = await response.json();
        console.error('Ошибка при улучшении меню:', errorData);
        this.controller.showToaster(errorData.error || 'Не удалось улучшить меню');
      }
    } catch (error) {
      console.error('Ошибка при улучшении меню:', error);
      this.controller.showToaster('Ошибка при улучшении меню');
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }
  }

  removeSectionControls(section) {
    // Remove section-specific event listeners
    if (section._sectionEventHandlers) {
      section.removeEventListener('mouseenter', section._sectionEventHandlers.mouseEnterHandler);
      section.removeEventListener('mouseleave', section._sectionEventHandlers.mouseLeaveHandler);
      delete section._sectionEventHandlers;
    }

    // Remove section controls element
    const sectionControls = section.querySelector('.section-controls');
    if (sectionControls) {
      sectionControls.remove();
    }

    // Reset section styles
    section.style.border = '';
  }

  cleanup() {
    console.log('Cleaning up SectionControls...');

    // Remove all tracked event listeners
    this.eventListeners.forEach(({ element, event, handler }) => {
      if (element && element.removeEventListener) {
        element.removeEventListener(event, handler);
      }
    });

    // Clear the array
    this.eventListeners = [];

    // Remove any existing refine inputs
    const existingRefineInput = document.querySelector('.refine-input-container');
    if (existingRefineInput) {
      existingRefineInput.remove();
    }

    // Remove section controls
    document.querySelectorAll('.section-controls').forEach(control => {
      control.remove();
    });

    // Clear references
    this.clickHandler = null;
  }

  async deleteSection(section) {
    const sectionId = section.id;

    if (!sectionId) {
      console.error('У раздела нет ID');
      this.controller.showToaster('У раздела нет ID для удаления');
      return;
    }

    try {
      const response = await fetch(`/api/v1/page_editor/delete_section?id=${sectionId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });

      if (response.ok) {
        section.remove();
        this.controller.showToaster('Раздел успешно удален');
      } else {
        const errorData = await response.json();
        console.error('Ошибка при удалении раздела:', errorData);
        this.controller.showToaster(errorData.error || 'Не удалось удалить раздел');
      }
    } catch (error) {
      console.error('Ошибка при удалении раздела:', error);
      this.controller.showToaster('Ошибка при удалении раздела');
    }
  }

  async saveSection(section) {
    const sectionId = section.id;

    if (!sectionId) {
      console.error('У раздела нет ID');
      this.controller.showToaster('У раздела нет ID для сохранения');
      return;
    }

    // Store the section controls to restore them later
    const controls = section.querySelector('.section-controls');
    const imageChangeButtons = section.querySelectorAll('.image-change-btn');
    const elementsToRestore = [];

    this.controller.restoreNavbarState();
    section.style.border = '';
    // Temporarily remove controls and image change buttons
    if (controls) {
      elementsToRestore.push({
        element: controls,
        parent: controls.parentNode,
        nextSibling: controls.nextSibling
      });
      controls.remove();
    }


    imageChangeButtons.forEach(btn => {
      elementsToRestore.push({
        element: btn,
        parent: btn.parentNode,
        nextSibling: btn.nextSibling
      });
      btn.remove();
    });

    // Get the section content BEFORE showing the loader
    let sectionContent = '';

    // Check if this section is a child of a header element
    const headerParent = section.closest('header');
    if (headerParent) {
      sectionContent = headerParent.outerHTML;
    } else {
      sectionContent = section.outerHTML;
    }

    // Restore the removed elements
    elementsToRestore.forEach(data => {
      if (data.nextSibling && data.parent.contains(data.nextSibling)) {
        data.parent.insertBefore(data.element, data.nextSibling);
      } else {
        data.parent.appendChild(data.element);
      }
    });

    try {
      const response = await fetch(`/api/v1/page_editor/save_section`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          id: sectionId,
          content: sectionContent
        })
      });

      if (response.ok) {
        this.controller.showToaster('Раздел успешно сохранен');
        this.controller.addNavbarBeforeFirstSection();
      } else {
        const errorData = await response.json();
        console.error('Ошибка при сохранении раздела:', errorData);
        this.controller.showToaster(errorData.error || 'Не удалось сохранить раздел');
      }
    } catch (error) {
      console.error('Ошибка при сохранении раздела:', error);
      this.controller.showToaster('Ошибка при сохранении раздела');
    }
  }

  async moveSectionUp(section) {
    const sectionId = section.id;

    if (!sectionId) {
      console.error('У раздела нет ID');
      this.controller.showToaster('У раздела нет ID для перемещения');
      return;
    }

    try {
      const response = await fetch(`/api/v1/page_editor/move_section_up?id=${sectionId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });

      if (response.ok) {
        // Move section up visually
        const prevSection = section.previousElementSibling;
        if (prevSection && prevSection.tagName === 'SECTION') {
          section.parentNode.insertBefore(section, prevSection);
        }
        this.controller.showToaster('Раздел успешно перемещен вверх');
      } else {
        const errorData = await response.json();
        console.error('Ошибка при перемещении раздела вверх:', errorData);
        this.controller.showToaster(errorData.error || 'Не удалось переместить раздел вверх');
      }
    } catch (error) {
      console.error('Ошибка при перемещении раздела вверх:', error);
      this.controller.showToaster('Ошибка при перемещении раздела вверх');
    }
  }

  async moveSectionDown(section) {
    const sectionId = section.id;

    if (!sectionId) {
      console.error('У раздела нет ID');
      this.controller.showToaster('У раздела нет ID для перемещения');
      return;
    }

    try {
      const response = await fetch(`/api/v1/page_editor/move_section_down?id=${sectionId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });

      if (response.ok) {
        // Move section down visually
        const nextSection = section.nextElementSibling;
        if (nextSection && nextSection.tagName === 'SECTION') {
          section.parentNode.insertBefore(nextSection, section);
        }
        this.controller.showToaster('Раздел успешно перемещен вниз');
      } else {
        const errorData = await response.json();
        console.error('Ошибка при перемещении раздела вниз:', errorData);
        this.controller.showToaster(errorData.error || 'Не удалось переместить раздел вниз');
      }
    } catch (error) {
      console.error('Ошибка при перемещении раздела вниз:', error);
      this.controller.showToaster('Ошибка при перемещении раздела вниз');
    }
  }

  showRefineModal(section) {
    console.log('Показываем компактное окно улучшения для раздела:', section.id);

    const sectionId = section.id;

    if (!sectionId) {
      console.error('У раздела нет ID');
      this.controller.showToaster('У раздела нет ID для улучшения');
      return;
    }

    // Remove any existing refine input
    const existingRefineInput = document.querySelector('.refine-input-container');
    if (existingRefineInput) {
      existingRefineInput.remove();
    }

    // Create compact input container
    const refineContainer = document.createElement('div');
    refineContainer.className = 'refine-input-container';
    refineContainer.style.cssText = `
      position: absolute;
      top: 40px;
      right: 10px;
      background: white;
      border: 1px solid #ced4da;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      padding: 12px;
      z-index: 9001;
      width: 300px;
      max-width: calc(100vw - 40px);
    `;

    // Create input field
    const textarea = document.createElement('textarea');
    textarea.placeholder = 'Введите запрос на изменение...';
    textarea.style.cssText = `
      width: 100%;
      min-height: 80px;
      padding: 8px;
      border: 1px solid #ced4da;
      border-radius: 4px;
      font-family: inherit;
      font-size: 13px;
      resize: vertical;
      box-sizing: border-box;
      margin-bottom: 8px;
    `;

    // Create button container
    const buttonContainer = document.createElement('div');
    buttonContainer.style.cssText = `
      display: flex;
      justify-content: flex-end;
      gap: 6px;
    `;

    const cancelButton = document.createElement('button');
    cancelButton.textContent = 'Отмена';
    cancelButton.style.cssText = `
      padding: 4px 8px;
      border: 1px solid #6c757d;
      background: #6c757d;
      color: white;
      border-radius: 3px;
      cursor: pointer;
      font-size: 12px;
    `;

    const refineButton = document.createElement('button');
    refineButton.textContent = 'Улучшить';
    refineButton.style.cssText = `
      padding: 4px 8px;
      border: 1px solid var(--primary-color);
      background: green;
      color: white;
      border-radius: 3px;
      cursor: pointer;
      font-size: 12px;
    `;

    buttonContainer.appendChild(cancelButton);
    buttonContainer.appendChild(refineButton);

    refineContainer.appendChild(textarea);
    refineContainer.appendChild(buttonContainer);

    // Add to section
    section.appendChild(refineContainer);

    // Focus on textarea
    textarea.focus();

    // Event handlers
    const closeRefineInput = () => {
      console.log('Закрываем компактное окно');
      refineContainer.remove();
    };

    cancelButton.addEventListener('click', closeRefineInput);

    // Close when clicking outside
    const handleClickOutside = (e) => {
      if (!refineContainer.contains(e.target)) {
        closeRefineInput();
        document.removeEventListener('click', handleClickOutside);
      }
    };
    setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 100);

    // Handle escape key
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeRefineInput();
        document.removeEventListener('keydown', handleKeyDown);
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    // Handle refine button click
    refineButton.addEventListener('click', () => {
      const modificationRequest = textarea.value.trim();
      if (!modificationRequest) {
        this.controller.showToaster('Пожалуйста, введите запрос на изменение');
        return;
      }

      closeRefineInput();
      this.refineSection(section, modificationRequest);
    });
  }

  async refineSection(section, modificationRequest) {
    const sectionId = section.id;

    if (!sectionId) {
      console.error('У раздела нет ID');
      this.controller.showToaster('У раздела нет ID для улучшения');
      return;
    }

    // Remove section controls and their events before refinement
    this.removeSectionControls(section);

    // Create and show loader
    const loader = this.createLoader();
    section.appendChild(loader);

    try {
      const response = await fetch(`/api/v1/page_editor/refine_section?id=${sectionId}&modification_request=${encodeURIComponent(modificationRequest)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });

      // Remove loader
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }

      if (response.ok) {
        const data = await response.json();

        // Update the section content
        section.outerHTML = data.section;

        // this.initializeSectionControls(section);
        // Reinitialize functionality for the updated section
        // this.controller.textEditor.initializeTextChangeHandlers();
        // this.controller.imageChangeHandler.initializeImageChangeHandlers();

        this.controller.showToaster('Раздел успешно улучшен');
      } else {
        const errorData = await response.json();
        console.error('Ошибка при улучшении раздела:', errorData);
        this.controller.showToaster(errorData.error || 'Не удалось улучшить раздел');
      }
    } catch (error) {
      console.error('Ошибка при улучшении раздела:', error);
      this.controller.showToaster('Ошибка при улучшении раздела');

      // Remove loader in case of error
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }
  }

  createLoader() {
    const loader = document.createElement('div');
    loader.className = 'section-loader';
    loader.style.cssText = `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 0.9);
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 9999;
      display: flex;
      align-items: center;
      gap: 10px;
    `;

    const spinner = document.createElement('div');
    spinner.style.cssText = `
      width: 20px;
      height: 20px;
      border: 2px solid #f3f3f3;
      border-top: 2px solid var(--primary-color);
      border-radius: 50%;
      animation: spin 1s linear infinite;
    `;

    const text = document.createElement('span');
    text.textContent = 'Улучшаем раздел...';
    text.style.cssText = `
      font-size: 14px;
      color: #333;
    `;

    loader.appendChild(spinner);
    loader.appendChild(text);

    // Add CSS animation for spinner
    if (!document.getElementById('loader-styles')) {
      const style = document.createElement('style');
      style.id = 'loader-styles';
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }

    return loader;
  }

  async saveFooter(footer) {
    // Get pageId from URL (number after 'pages/')
    const match = window.location.pathname.match(/pages\/(\d+)/);
    const pageId = match ? match[1] : null;

    if (!pageId) {
      this.controller.showToaster('Не удалось определить ID страницы');
      return;
    }

    // Store the footer controls to restore them later
    const controls = footer.querySelector('.footer-controls');
    const elementsToRestore = [];

    footer.style.border = '';
    // Temporarily remove controls
    if (controls) {
      elementsToRestore.push({
        element: controls,
        parent: controls.parentNode,
        nextSibling: controls.nextSibling
      });
      controls.remove();
    }

    // Get the footer content BEFORE showing the loader
    const footerContent = footer.outerHTML;

    // Restore the removed elements
    elementsToRestore.forEach(data => {
      if (data.nextSibling && data.parent.contains(data.nextSibling)) {
        data.parent.insertBefore(data.element, data.nextSibling);
      } else {
        data.parent.appendChild(data.element);
      }
    });

    // Show loader
    const loader = this.createLoader();
    footer.appendChild(loader);

    try {
      const response = await fetch(`/api/v1/page_editor/save_footer`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          page_id: pageId,
          content: footerContent
        })
      });

      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }

      if (response.ok) {
        this.controller.showToaster('Футер успешно сохранён');
      } else {
        const errorData = await response.json();
        this.controller.showToaster(errorData.error || 'Не удалось сохранить футер');
      }
    } catch (error) {
      this.controller.showToaster('Ошибка при сохранении футера');
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }
  }

  async saveNavbar(navbar) {
    // Get pageId from URL (number after 'pages/')
    const match = window.location.pathname.match(/pages\/(\d+)/);
    const pageId = match ? match[1] : null;

    if (!pageId) {
      this.controller.showToaster('Не удалось определить ID страницы');
      return;
    }

    // Store the navbar controls to restore them later
    const controls = navbar.querySelector('.navbar-controls');
    const elementsToRestore = [];

    navbar.style.border = '';
    // Temporarily remove controls
    if (controls) {
      elementsToRestore.push({
        element: controls,
        parent: controls.parentNode,
        nextSibling: controls.nextSibling
      });
      controls.remove();
    }

    // Get the navbar content BEFORE showing the loader
    const navbarContent = navbar.outerHTML;

    // Restore the removed elements
    elementsToRestore.forEach(data => {
      if (data.nextSibling && data.parent.contains(data.nextSibling)) {
        data.parent.insertBefore(data.element, data.nextSibling);
      } else {
        data.parent.appendChild(data.element);
      }
    });

    // Show loader
    const loader = this.createLoader();
    navbar.appendChild(loader);

    try {
      const response = await fetch(`/api/v1/page_editor/save_header`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          page_id: pageId,
          content: navbarContent
        })
      });

      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }

      if (response.ok) {
        this.controller.showToaster('Меню успешно сохранено');
      } else {
        const errorData = await response.json();
        this.controller.showToaster(errorData.error || 'Не удалось сохранить меню');
      }
    } catch (error) {
      this.controller.showToaster('Ошибка при сохранении меню');
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }
  }
}
